/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */
export const hexToRgb = (hex: string) => {
  if (!hex) {
    throw new Error("Invalid Hexadecimal Color Code.");
  }
  // Remove the # character if present
  hex = hex.replace("#", "");

  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  // Verify if the input is a valid hexadecimal color code
  const validHexRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

  if (!validHexRegex.test(hex)) {
    throw new Error("Invalid Hexadecimal Color Code.");
  }

  // Use nullish coalescing operator (??) to provide an empty array as default
  const matches = hex.match(/[A-Fa-f0-9]{2}/g) ?? [];
  // Convert the hex value to decimal
  const [r, g, b] = matches.map((value) => parseInt(value, 16));

  // Return the RGB values as an object
  return {
    r,
    g,
    b,
  };
};
